'use client';

import React, { useEffect } from 'react';

import { usePictureViewerContext } from 'providers/picture-viewer-provider';

import { styles } from '.';
import PictureItem from '../PictureItem';

type TProps = {
  pictures: any[];
};

const PictureViewer = (props: TProps) => {
  const { pictures } = props;

  const { setPictures, setSelector, setIsShown } = usePictureViewerContext();

  useEffect(() => {
    setPictures(pictures);
  }, [pictures, setPictures]);

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        <li className={styles.tiles.primary}>
          <PictureItem
            picture={pictures?.[0]}
            //
            onClick={() => {
              setSelector(0);
              setIsShown(true);
            }}
          />
        </li>
        <li className={styles.tiles.secondary}>
          <PictureItem
            picture={pictures?.[1]}
            //
            onClick={() => {
              setSelector(1);
              setIsShown(true);
            }}
          />
          <div className={styles.tiles.tertiary}>
            <PictureItem
              picture={pictures?.[2]}
              //
              onClick={() => {
                setSelector(2);
                setIsShown(true);
              }}
            />
            <div className={styles.tiles.button} onClick={() => setSelector(3)}>
              {(pictures?.length ?? 3) - 3}+
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default PictureViewer;
